var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSetupRightButtonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 16,
    viewBox: "0 0 37 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.666,
    width: 17.3333,
    height: 16,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.668 8.00174C18.668 7.38809 18.7259 6.89062 18.7974 6.89062H29.6496C29.7211 6.89062 29.7791 7.38809 29.7791 8.00174C29.7791 8.61539 29.7211 9.11285 29.6496 9.11285H18.7974C18.7259 9.11285 18.668 8.61539 18.668 8.00174Z",
    fill: "#1C1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3507 2.11436C25.649 1.81605 26.1327 1.81605 26.431 2.11436L31.7782 7.46159C32.0765 7.7599 32.0765 8.24357 31.7782 8.54189L26.431 13.8891C26.1327 14.1874 25.649 14.1874 25.3507 13.8891C25.0524 13.5908 25.0524 13.1071 25.3507 12.8088L30.1578 8.00174L25.3507 3.19466C25.0524 2.89635 25.0524 2.41268 25.3507 2.11436Z",
    fill: "#1C1C1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.9974C0 7.26102 0.10434 6.66406 0.233051 6.66406H19.7669C19.8957 6.66406 20 7.26102 20 7.9974C20 8.73378 19.8957 9.33073 19.7669 9.33073H0.233051C0.10434 9.33073 0 8.73378 0 7.9974Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSetupRightButtonArrow);
export default __webpack_public_path__ + "static/media/profile-setup-right-button-arrow.04748e4aa086597a11a4335b5fb0347f.svg";
export { ForwardRef as ReactComponent };